import {z} from 'zod';
import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {baseCardSchema} from './baseSchemas';

// Weighted Card Schema
const weightedNodeOutputSchema = z.object({
  name: z.string().describe('The name of the output'),
  weight: z
    .number()
    .int({message: 'The weight must be a whole number'})
    .positive()
    .describe(
      'The weight of the output. Initially set to 100% for each output. Always use real numbers, not percentages.',
    ),
});

export const weightedCardSchema = baseCardSchema.extend({
  type: z.literal(NodeType.WEIGHTED),
  shouldSplitAudience: z
    .boolean()
    .describe(
      'Enable Audience Split for manual A/B testing when you need distinct user groups exposed to only one output each. Set to false if not requested otherwise by the user',
    ),
  outputs: z.array(weightedNodeOutputSchema),
});
